import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-beyond-traditional-blackboard-era-of-interactive-learning',
  templateUrl: './beyond-traditional-blackboard-era-of-interactive-learning.component.html',
  styleUrls: ['./beyond-traditional-blackboard-era-of-interactive-learning.component.scss']
})
export class BeyondTraditionalBlackboardEraOfInteractiveLearningComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Beyond the Traditional Blackboard: The Era of Interactive Learning | VIRSA');
    this.metaService.updateTag({
      name: 'description',
      content: 'Discover how Virsa Interactive Flat Panels and digital learning tools are transforming traditional classrooms into interactive learning environments with VIRSA smart classroom solutions.'
    });
    this.metaService.updateTag({
      name: 'keywords',
      content: 'interactive learning, interactive classroom, traditional blackboard to smart classroom, Virsa interactive Flat Panel for schools, interactive learning technology, smart classroom solutions, digital classroom, interactive teaching, digital learning solutions, VIRSA Interactive Flat Panel, interactive learning in schools, smart classroom technology, digital teaching tools, modern classroom technology, Interactive Flat Panel benefits, classroom digitization, technology enabled learning, interactive digital classroom, EdTech solutions for schools'
    });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
